import {StoreConstants} from '../constants/store.constants';

export const DeviceActions = {
  load: (data: any) => ({
    group: StoreConstants.StoreGroups.Device,
    type: StoreConstants.Device.DATA,
    ...data
  }),
  data: (data: any) => ({
    group: StoreConstants.StoreGroups.Device,
    type: StoreConstants.Device.DATA,
    data
  })
};
